import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { LiveLoader } from './components/live-loader';
import { ScriptLoader } from './components/script-loader';
import Root from './pages/root';
import store from './store';

const render = () => {
  ReactDOM.render(
    <ScriptLoader>
      <React.Fragment>
        <LiveLoader />
        <Provider store={store}>
          <Root />
        </Provider>
      </React.Fragment>
    </ScriptLoader>,
    document.getElementById('root')
  );
};

render();

if (module.hot) {
  module.hot.accept('./pages/root', function () {
    render();
  });
}



// WEBPACK FOOTER //
// ./src/index.js